import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AccessLevel } from 'lavva.exalushome/build/js/Services/Users/IUser';
import { CustomBackdrop, Header, NavHeader, Page, SubmitButton } from '../../../../components';
import { ROUTES } from '../../../../routes/routes';
import { useExalusUsers } from '../../hooks/users';
import { UserItem } from '../../types';
import UserListItem from './components/user-item';
import './index.scss';

const ExalusUsersList: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('profile');
  const { data, isLoading } = useExalusUsers();

  const handleRedirect = () => navigate(ROUTES.UserCreate());

  return (
    <Page
      isStickyHeader
      header={
        <>
          <NavHeader />
          <Header title={t('exalus.exalusUsers')} isUnderline />
        </>
      }
    >
      <div className="exalus-users">
        <div>
          {data
            ?.filter(({ user }: UserItem) => user.AccessLevel !== AccessLevel.Support)
            .map(({ user, image }: UserItem) => (
              <UserListItem key={user.Guid} user={user} image={image} />
            ))}
        </div>
        <SubmitButton type="button" onClick={handleRedirect}>
          {t('exalus.createNew')}
        </SubmitButton>
      </div>
      <CustomBackdrop loading={isLoading} />
    </Page>
  );
};

export default ExalusUsersList;
